import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    addTender,
    deleteTender,
    editTender,
    getTenders,
} from "./tenderAPI";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const initialState = {
    accounts: [],
    isLoading: false,
    isError: false,
    error: "",
    editing: {},
};

// async thunks
export const fetchAccounts = createAsyncThunk(
    "tender/fetchTenders",
    async () => {
        const tender = await getTenders();
       
        return tender;
              }
);

export const createAccount = createAsyncThunk(
    "tender/createTenders",
    async (data,thunkAPI) => {
        const tender = await addTender(data);
        toast.success('Account created successfully!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000, // Close after 3 seconds
          });
        //   thunkAPI.dispatch(fetchAccounts());
        return tender;
        
    }
);

export const changeAccount = createAsyncThunk(
    "accounts/changeAccount",
    async ({ id, data }) => {
        const accounts = await editTender(id, data);
        toast.success('Account updated successfully!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000, // Close after 3 seconds
          });
        return accounts;
    }
);

export const removeAccount = createAsyncThunk(
    "tender/removeAccount",
    async (id) => {
        const account = await deleteTender(id);
        toast.success('Account deleted successfully!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000, // Close after 3 seconds
          });
        return account;
    }
);

// create slice
const tenderSlice = createSlice({
    name: "tender",
    initialState,
    reducers: {
        editActive: (state, action) => {
             console.log(action.payload);
            state.editing = action.payload;
        },
        editInActive: (state) => {
            state.editing = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAccounts.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchAccounts.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.accounts = action.payload;
            })
            .addCase(fetchAccounts.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
                state.accounts = [];
            })
            .addCase(createAccount.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(createAccount.fulfilled, (state, action) => {
    
                state.isError = false;
                state.isLoading = false;
                state.accounts.unshift(action.payload);
            })
            .addCase(createAccount.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(changeAccount.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(changeAccount.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;

                const indexToUpdate = state.accounts.findIndex(
                    (t) => t.id === action.payload.id
                );

                state.accounts[indexToUpdate] = action.payload;
            })
            .addCase(changeAccount.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(removeAccount.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(removeAccount.fulfilled, (state, action) => {
                console.log(action);
                state.isError = false;
                state.isLoading = false;

                state.accounts = state.accounts.filter(
                    (t) => t.id !== action.meta.arg
                );
            })
            .addCase(removeAccount.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default tenderSlice.reducer;
export const { editActive, editInActive } = tenderSlice.actions;
